exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".in-progress-observations {\n  flex: 1 0 auto;\n  padding-bottom: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/InProgressObservations.styl
// module id = 1900
// module chunks = 1